<script lang="ts">
	import type { Component } from 'svelte';
	import type { PageBlocks, PostBlocks } from '#lib/schema-extension.js';
	import DirectusCard from '#lib/directus/components/Directus_card.svelte';
	import DirectusGameReport from '#lib/directus/components/Directus_gameReport.svelte';
	import DirectusHeroSlider from '#lib/directus/components/Directus_heroSlider.svelte';
	import DirectusNextMatch from '#lib/directus/components/Directus_nextMatch.svelte';
	import DirectusPostGrid from '#lib/directus/components/Directus_postGrid.svelte';
	import DirectusSchedule from '#lib/directus/components/Directus_schedule.svelte';
	import DirectusSlider from '#lib/directus/components/Directus_slider.svelte';
	import DirectusStandings from '#lib/directus/components/Directus_standings.svelte';

	const blockTypes = {
		card: DirectusCard,
		gameReport: DirectusGameReport,
		heroSlider: DirectusHeroSlider,
		nextMatch: DirectusNextMatch,
		postGrid: DirectusPostGrid,
		schedule: DirectusSchedule,
		slider: DirectusSlider,
		standings: DirectusStandings
	};

	let {
		blocks
	}: {
		blocks: (string | PageBlocks | PostBlocks)[];
	} = $props();
</script>

{#if blocks}
	{#each blocks as block}
		{#if typeof block !== 'string' && block.collection && block.collection in blockTypes && block.item && typeof block.item === 'object'}
			<!-- Directus returns a polymorphic item; its collection determines the component contract. -->
			{@const DirectusComponent = blockTypes[
				block.collection as keyof typeof blockTypes
			] as Component<{ block: typeof block.item }>}
			<DirectusComponent block={block.item} />
		{/if}
	{/each}
{/if}
